import React, { useEffect, useState } from "react";
import { Card, Offcanvas } from "react-bootstrap";
import SubjectQueryBarGraph from "./Graph/SubjectQueryBarGraph";
import SiteSDVDonutGraph from "./Graph/SiteSDVDonutGraph";
import SiteEntryProgressGraph from "./Graph/SiteEntryProgressGraph";
import { studySiteDataEntryServices } from "../../../../../APIServices/studySiteDataEntryServices";
import { useParams } from "react-router";
import SubjectNotificationBarGraph from "./Graph/SubjectNotificationBarGraph";

const ViewSubjectGraph = ({ Show, Hide, Title, siteId }) => {
  const [siteQuery, setSiteQuery] = useState([]);
  const [siteNotification, setSiteNotification] = useState([]);
  const [siteSDV, setSiteSDV] = useState(0);
  const [siteDataEntry, setSiteDataEntry] = useState(0);

  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams();

  const getStudyFormBySiteTotalQuery = async () => {
    setSiteQuery([]);
    let userData = {}
    userData.siteId = siteId
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyFormBySiteTotalQuery(userData)
    setSiteQuery(data?.data);
  };

  const getStudyFormBySiteTotalNotification = async () => {
    setSiteNotification([]);
    let userData = {}
    userData.siteId = siteId
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyFormBySiteTotalNotification(userData)
    setSiteNotification(data?.data);
  };

  const getStudyBySiteFormSDVHistory = async () => {
    setSiteSDV([]);
    let userData = {}
    userData.siteId = siteId
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyBySiteFormSDVHistory(userData)
    setSiteSDV(data?.data);
  };

  const getStudyBySiteFormDataEntry = async () => {
    setSiteDataEntry([]);
    let userData = {}
    userData.siteId = siteId
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyBySiteFormDataEntry(userData)
    setSiteDataEntry(data?.data);
  };

  useEffect(() => {
    if (siteId !== "no") {
      getStudyFormBySiteTotalQuery()
      getStudyFormBySiteTotalNotification()
      getStudyBySiteFormSDVHistory()
      getStudyBySiteFormDataEntry()
    }
  }, [siteId]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="br3 bg-light shadow-sm border mb-3">
            <SubjectQueryBarGraph siteQuery={siteQuery} />
          </Card>
          <Card className="br3 bg-light shadow-sm border mb-3">
            <SubjectNotificationBarGraph siteNotification={siteNotification} />
          </Card>
          <Card className="br3 bg-light shadow-sm border mb-3">
            <SiteSDVDonutGraph siteSDV={siteSDV} />
          </Card>
          <Card className="br3 bg-light shadow-sm border">
            <SiteEntryProgressGraph siteDataEntry={siteDataEntry} />
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ViewSubjectGraph;
